import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const physicalStopsApiRoutes = {
    list: apiDataManagerBaseURL + "physicalstops/",
};

export class PhysicalStopAPI {
    static list() {
        const url = new URL("withoutmappoint", physicalStopsApiRoutes.list);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
